module.exports = "<div class=\"flex-inner-container\">\r\n    <div class=\"chart-legend\" #legendDiv></div>\r\n</div>"